/* @flow */

import * as React from 'react';
import classNames from 'classnames';

import {Stack} from 'shells/layout';
import {Body} from 'shells/typography';
import {LoadingIcon} from 'shells/icon';
import {ButtonCard} from 'shells/card';
import {colors} from 'shells/colors';

import type {
    GetSuggestedReplies_suggestedReplies as SuggestedReplies,
    GetSuggestedReplies_suggestedReplies_replies as SuggestedReply,
} from 'nutshell-graphql-types';

import {SuggestedReplyStatus} from './';

type Props = {|
    suggestedReplies: ?SuggestedReplies,
    isLoading: ?boolean,
    onCardClicked: (reply: SuggestedReply) => void,
    variant?: 'full' | 'sparse',
|};

export function SuggestedReplyCards(props: Props) {
    const {variant = 'sparse'} = props;

    const cardClassNames = classNames('flex full-width', {
        'gap-16': variant === 'full',
        'gap-8': variant === 'sparse',
    });

    const hasError =
        props.suggestedReplies && props.suggestedReplies.status === SuggestedReplyStatus.ERROR;

    return (
        <>
            {props.isLoading && (
                <div className='flex justify-center disabled'>
                    <LoadingIcon fill={colors.greyLt} />
                </div>
            )}
            {hasError && !props.isLoading && (
                <Body size='small' color='error'>
                    Error loading suggested replies
                </Body>
            )}
            {!props.isLoading && !hasError && props.suggestedReplies && (
                <div className={cardClassNames}>
                    {props.suggestedReplies.replies.map((reply) => (
                        <ButtonCard
                            key={reply.id}
                            isFullWidth={true}
                            onClick={(e) => {
                                e.stopPropagation();
                                props.onCardClicked(reply);
                            }}
                            hasOffWhiteBackground={true}
                        >
                            <div className='pad-8 full-width border-box text-align-left'>
                                <Stack spacing={2}>
                                    <Body
                                        size='small'
                                        color='navy-dk'
                                        shouldTruncate={true}
                                        isBold={true}
                                    >
                                        {reply.title}
                                    </Body>
                                    {variant === 'full' && (
                                        <Body size='small' color='navy-dk' shouldTruncate={true}>
                                            {reply.body}
                                        </Body>
                                    )}
                                </Stack>
                            </div>
                        </ButtonCard>
                    ))}
                </div>
            )}
        </>
    );
}
